$(document).ready(() => {
    const $navbarSearch = $('#navbarSearchForm');
    const $searchToggle = $('.js-search-toggle');
    const $searchClose = $('#navbarSearchClose');
    const $searchInput = $('#navbarSearchInput');

    // Set initial ARIA attributes
    $searchToggle.attr({
        'aria-expanded': 'false',
        'aria-controls': 'navbarSearchForm'
    });
    $navbarSearch.attr('role', 'region').attr('aria-hidden', 'true');
    $searchClose.attr('aria-label', 'Close search');

    // Close all dropdowns
    const closeAllDropdowns = () => {
        $('.nav-link.sub-toggle').removeClass('show').attr('aria-expanded', 'false');
        $('.sub-menu').removeClass('show');
    };

    // Sets focus on the search input
    const focusSearchInput = () => {
        setTimeout(() => {
            $searchInput.focus();
        }, 100);
    };

    // Function to trap focus within the search modal
    const trapFocus = (event) => {
        const focusableElements = $navbarSearch.find('input, button, [tabindex]:not([tabindex="-1"])');
        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement = focusableElements[focusableElements.length - 1];

        if (event.key === 'Tab') {
            if (event.shiftKey) {
                // If Shift+Tab is pressed, cycle backward
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    event.preventDefault();
                }
            } else {
                // If Tab is pressed, cycle forward
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    event.preventDefault();
                }
            }
        }
    };

    // Toggle .show class and update ARIA attributes on search toggle click
    $searchToggle.on('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const isExpanded = $navbarSearch.hasClass('show');

        // Close all dropdowns when toggling the search
        closeAllDropdowns();

        if (isExpanded) {
            $navbarSearch.removeClass('show').attr('aria-hidden', 'true');
            $searchToggle.attr('aria-expanded', 'false');
        } else {
            $navbarSearch.addClass('show').attr('aria-hidden', 'false');
            $searchToggle.attr('aria-expanded', 'true');
            focusSearchInput();
        }
    });

    // Close #navbarSearch when clicking outside and update ARIA attributes
    $(document).on('click', (e) => {
        const $target = $(e.target);

        if (!$target.closest('#navbarSearchForm').length && !$target.is('js-search-toggle')) {
            $navbarSearch.removeClass('show').attr('aria-hidden', 'true');
            $searchToggle.attr('aria-expanded', 'false');
        }
    });

    // Prevent clicks inside #navbarSearch from closing it
    $navbarSearch.on('click', (e) => {
        e.stopPropagation();
    });

    // Close #navbarSearch when clicking on #navbarSearchClose
    $searchClose.on('click', (e) => {
        e.preventDefault();

        $searchToggle.focus();
        $navbarSearch.removeClass('show').attr('aria-hidden', 'true');
        $searchToggle.attr('aria-expanded', 'false');
    });

    // Close search when ESC key is pressed and return focus to the search toggle button
    $(document).on('keydown', (e) => {
        if (e.key === 'Escape' && $navbarSearch.hasClass('show')) {
            $searchToggle.focus();
            $navbarSearch.removeClass('show').attr('aria-hidden', 'true');
            $searchToggle.attr('aria-expanded', 'false');
        }
    });

    // Trap focus within the search modal
    $navbarSearch.on('keydown', trapFocus);
});
